(() => {
  const padQty = (input) => {
    const display = input?.parentElement?.querySelector('[data-nn-qty-display]');
    if (!input || !display) return;
    const n = parseInt(input.value, 10);
    display.textContent = Number.isFinite(n) ? String(n).padStart(2, '0') : input.value;
  };

  const bindQty = (root) => {
    root.querySelectorAll('.nn-qty .quantity__input').forEach((input) => {
      if (input.dataset.nnQtyBound === 'true') return;
      input.dataset.nnQtyBound = 'true';
      padQty(input);
      input.addEventListener('input', () => padQty(input));
      input.addEventListener('change', () => padQty(input));
      input.closest('quantity-input')?.querySelectorAll('.quantity__button').forEach((btn) => {
        btn.addEventListener('click', () => requestAnimationFrame(() => padQty(input)));
      });
    });
  };

  const bindGallery = (root) => {
    const gallery = root.querySelector('.nn-pdp__gallery');
    if (!gallery || gallery.dataset.nnBound === 'true') return;
    gallery.dataset.nnBound = 'true';

    const mainImg = gallery.querySelector('.nn-pdp__main img');
    gallery.querySelectorAll('[data-nn-thumb]').forEach((btn) => {
      btn.addEventListener('click', () => {
        gallery.querySelectorAll('[data-nn-thumb]').forEach((other) => {
          other.classList.toggle('is-active', other === btn);
          other.setAttribute('aria-pressed', other === btn ? 'true' : 'false');
        });
        if (!mainImg) return;
        mainImg.src = btn.dataset.nnSrc;
        if (btn.dataset.nnSrcset) mainImg.srcset = btn.dataset.nnSrcset;
        if (btn.dataset.nnAlt) mainImg.alt = btn.dataset.nnAlt;
      });
    });
  };

  const restoreOptionAccordions = (root) => {
    const active = document.activeElement;
    root.querySelectorAll('variant-selects details.nn-acc').forEach((details, index) => {
      if (index === 0 || details.contains(active)) details.open = true;
    });
  };

  const bindRoot = (root) => {
    if (!root) return;
    bindGallery(root);
    bindQty(root);
  };

  const init = () => {
    document.querySelectorAll('product-info.nn-pdp-root').forEach(bindRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root =
      event.target.querySelector?.('product-info.nn-pdp-root') || event.target.closest?.('product-info.nn-pdp-root');
    bindRoot(root);
  });

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const root = document.querySelector(`#MainProduct-${data.sectionId}`);
      if (!root) return;

      const live = root.querySelector('.nn-pdp__gallery');
      const next = data.html.querySelector(`#MainProduct-${data.sectionId} .nn-pdp__gallery`);
      if (live && next) {
        live.replaceWith(next.cloneNode(true));
      }

      requestAnimationFrame(() => {
        bindRoot(root);
        restoreOptionAccordions(root);
        const nextJuices = data.html.querySelector('[data-nn-juices-heading]');
        const liveJuices = root.querySelector('[data-nn-juices-heading]');
        if (nextJuices && liveJuices) liveJuices.textContent = nextJuices.textContent;
      });
    });
  }
})();
